import CompanyBillingInvoice from 'pages/organisations/companies/v5/tabs/CompanyBillingInvoice';

const WholesalerBillingInvoice = (props) => (
    <CompanyBillingInvoice
        {...props}
        isCompany={false}
        organisationMode="Wholesaler"
    />
);

export default WholesalerBillingInvoice;
